import React from "react";
import {
  Box,
  Text,
  Button,
  useColorModeValue,
  Flex,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem
} from "@chakra-ui/react";
import { getBid } from "../../lib/Auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const CustomizeAIAssistantHeader = ({ draft = "" }) => {
  const bgColor = useColorModeValue("gray.100", "gray.700");
  const navigate = useNavigate();
  const bid = getBid();

  return (
    <Box p={1} bgColor={bgColor} borderRadius="md" width="full">
      <Flex align="center" minH="90px" flexDirection="column" alignItems="start">
        <Flex flexDirection="row" alignItems="center" width="100%">
          <Flex justifyContent="flex-start">
            <Text fontSize="sm" fontWeight="bold" mb={2} ml={2}>
              AI setup Assistant
            </Text>
          </Flex>
          <Flex justifyContent="flex-end" ml='auto' gap={2}  my={1} mr={2} minHeight="40px" alignItems="center">
            <Menu flexBasis="5%">
              <MenuButton as={IconButton} aria-label="Options" icon={<FontAwesomeIcon icon={faEllipsisV}/>}
                          variant="ellipsis"/>
              <MenuList>
                <MenuItem onClick={() => navigate(`/settings/customize-ai/history?bid=${getBid()}&assisted=1`)}>
                  Setup History
                </MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Flex>
        <Flex justifyContent='center' alignItems='center' width='100%' height='100%'>
          <Button
            fontSize="sm"
            borderRadius='12px'
            width="70px"
            height="32px"
            onClick={() => navigate(`/settings/customize-ai/assistant?bid=${bid}`)}>
            {draft? "Continue" : "Start"}
          </Button>
        </Flex>
      </Flex>
    </Box>
  )
};

export default CustomizeAIAssistantHeader;
